import React, { useState, useEffect, useRef } from "react";
import {
  Row,
  Card,
  CardBody,
  Input,
  FormGroup,
  Label,
  Button,
  Form,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalBody,
  Table,
  CardHeader,
  CardFooter,
  Col,
} from "reactstrap";
import { useHistory } from "react-router-dom";
import Pagination from "../../../containers/pages/Pagination";
import { Colxx } from "../../../components/common/CustomBootstrap";
import Accordion from "react-bootstrap/Accordion";
import { TeamMemberService } from "../../../../src/services/TeamMemberService";
import { toast } from "react-toastify";
import { BsFillCaretDownFill } from "react-icons/bs";
import { BsFillCaretUpFill } from "react-icons/bs";
import { isNullOrEmpty } from "../../../config/ENV";
import { formatPhoneNumber } from "../../../../src/utilities/phoneutility";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import SvgUpArrow from "../../../components/svg/uparrow";
import SvgSelectedDownArrow from "../../../components/svg/selecteddownarrow";
import SvgSelectedUpArrow from "../../../components/svg/selecteduparrow";
import SvgDownArrow from "../../../components/svg/downarrow";
import {formattedMobileNumber, getPhoneNumberByCountryCode,validatePhoneNumber,
  getCountryCodefromMobile,getMobileNumberCountryCode} from '../../../utilities/phonenumberutility';

const MembersList = ({ match, onSearchKey }) => {
  const [currentPage, setCurrentPage] = useState(1);
  let [itemsPerPage, setItemsPerPage] = useState();
  const [selectedPageSize, setSelectedPageSize] = useState(2);
  const [selectedOrderOption, setSelectedOrderOption] = useState({
    column: "DRAFT",
    label: "DRAFT",
  });
  const [totalPage, setTotalPage] = useState(1);
  const [search, setSearch] = useState("");

  const startIndex = (currentPage - 1) * selectedPageSize;
  const endIndex = currentPage * selectedPageSize;
  const [members, setMembers] = useState([]);
  const [modalRight, setModalRight] = useState(false);
  const [size, setSize] = useState();
  const [sortOrder, setSortOrder] = useState("asc");
  const [sortBy, setSortBy] = useState("firstName");
  const [teamMemberId, setTeamMemberId] = useState("");

  const [memberName, setMemberName] = useState("");

  const [userRoleOptions, setUserRoleOptions] = useState([]);
  const [userStatusOptions, setUserStatusOptions] = useState([]);
  const [role, setRole] = useState("");
  const [userStatus, setUserStatus] = useState("");
  const [selectedTeamMember, setSelectedTeamMember] = useState("");
  const [searchRole, setSearchRole] = useState("");
  const [saveBtnDisabled, setSaveBtnDisabled] = useState(false);
  const [cancelBtnDisabled, setCancelBtnDisabled] = useState(false);
  const [modalinactive, setModalinactive] = useState(false);
  const [modalactivate, setModalactivate] = useState(false);
  const [modalDelete, setModalDelete] = useState(false);
  const [isSortBySelected, setIsSortBySelected] = useState(false);

  const [mobileNumber, setMoblieNumber] = useState("");
  const [mobileNumberCountryCode, setMobileNumberCountryCode] = useState("1");

  const history = useHistory();
  const dropzone = useRef();

  const [teamMember, setTeamMember] = useState({
    firstName: "",
    lastName: "",
    displayName:"",
    email: "",
    contactNumber: "",
    role: "",
  });
  const [contactNumber, setContactNumber] = useState("");
  const handleContactNumber = (value, country) => {
    setContactNumber(value);

    if (country != null) {
      let dialCode = country.dialCode;
      let countryCode = country.countryCode;
      let dialCodeLength = dialCode.length;
      let number = value.slice(dialCodeLength).replace(/\D/g, "");
      let mobileNumber = getPhoneNumberByCountryCode(number, countryCode);
      setMobileNumberCountryCode(dialCode);
      setMoblieNumber(mobileNumber);
    }
  };
  const inputsHandler = (e) => {
    const { name, value } = e.target;

    if (name === "name" && value !== "") {
      setTeamMember((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    } else {
      setTeamMember((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  function handleSearch(e, key) {
    setSearch(e.target.value.toLowerCase());
  }

  function handleItemsPerChange(e, key) {
    setItemsPerPage(e.target.value);
    setCurrentPage(1);
  }

  function onChangePage(e) {
    setCurrentPage(e);
  }

  const sortByMembers = (col) => {
    setIsSortBySelected(true);
    setSortBy(col);
    sortedOrder(col, true);
  };
  const sortedOrder = (col, isSortBySelected) => {
    var select = "";
    if (sortOrder === "desc") {
      setSortOrder("asc");
      select = "asc";
    } else {
      setSortOrder("desc");
      select = "desc";
    }

    getAllTeamMembers(select, col, currentPage, true);
  };

  useEffect(() => {
    getUserEnums();
    getAllTeamMembers(sortOrder, sortBy, currentPage, isSortBySelected);
  }, [itemsPerPage, currentPage]);

  useEffect(() => {
    setCurrentPage(1);
  }, [selectedPageSize, selectedOrderOption]);

  const getAllTeamMembers = (
    sortOrder,
    sortBy,
    currentpage,
    isSortBySelected
  ) => {
    if (itemsPerPage === undefined || itemsPerPage === "") {
      itemsPerPage = 25;
    }

    if (sessionStorage.getItem("memberSortBy") !== null) {
      const sortByValue = sessionStorage.getItem("memberSortBy");
      if (!isNullOrEmpty(sortByValue)) {
        if (!isSortBySelected) {
          sortBy = sortByValue;
          setSortBy(sortBy);
        } else {
          sessionStorage.setItem("memberSortBy", sortBy);
        }
      } else {
        sessionStorage.setItem("memberSortBy", sortBy);
      }
    } else {
      sessionStorage.setItem("memberSortBy", sortBy);
    }

    if (sessionStorage.getItem("memberSortOrder") !== null) {
      const sortOrderValue = sessionStorage.getItem("memberSortOrder");
      if (!isNullOrEmpty(sortOrderValue)) {
        if (!isSortBySelected) {
          sortOrder = sortOrderValue;
          setSortOrder(sortOrder);
        } else {
          sessionStorage.setItem("memberSortOrder", sortOrder);
        }
      } else {
        sessionStorage.setItem("memberSortOrder", sortOrder);
      }
    } else {
      sessionStorage.setItem("memberSortOrder", sortOrder);
    }

    setCurrentPage(currentpage);
    TeamMemberService.getEmployerTeamMembers(
      search,
      userStatus,
      searchRole,
      itemsPerPage,
      currentpage,
      sortBy,
      sortOrder
    ).then((response) => {
      try {
        if (response.data != null) {
          let size = response.data.size;
          setSize(size);
          var teamMembers = response.data.members;
          setMembers(teamMembers);
          const pages = Math.floor(size / itemsPerPage);
          if (Math.round(size % itemsPerPage) > 0) {
            const totalPages = pages + 1;
            setTotalPage(totalPages);
          } else {
            const totalPages = pages;
            setTotalPage(totalPages);
          }
        }
      } catch (err) {
        console.log(err);
      }
    });
  };

  const getUserEnums = () => {
    TeamMemberService.getUserMetaEnums().then((response) => {
      try {
        if (response.status === 200) {
          setUserRoleOptions(response.data.userRoles);
          setUserStatusOptions(response.data.userStatus);
        }
      } catch (err) {
        console.log(err);
      }
    });
  };

  function handleUserRoleSelectChange(e, key) {
    setRole(e.target.value);
  }
  function handleUserRoleSearchChange(e, key) {
    setSearchRole(e.target.value);
  }

  const handleUserStatusSelectChange = (e) => {
    setUserStatus(e.target.value);
  };

  const handleMemberdelete = (deleteId, name) => {
    setTeamMemberId(deleteId);
    setMemberName(name);
    setModalDelete(deleteId);
  };
  const removeTeamMember = () => {
    TeamMemberService.deleteEmployerTeamMember(teamMemberId).then(
      (response) => {
        try {
          toast.success("Member terminated successfully");
          getAllTeamMembers(sortOrder, sortBy, currentPage);
        } catch (err) {
          console.log(err);
        }
        setModalDelete(false);
      }
    );
  };

  const SubmitMemberInfo = () => {
    if (teamMember.firstName === "") {
      toast.error("Please enter first name");
      return;
    }
    if (teamMember.lastName === "") {
      toast.error("Please enter last name");
      return;
    }

    if (teamMember.displayName === "") {
      toast.error("Please enter display name");
      return;
    }

    if (teamMember.email === "") {
      toast.error("Please enter email");
      return;
    }

    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(teamMember.email)) {
      toast.error("please enter valid email");
      return;
    }

    if (isNullOrEmpty(contactNumber)) {
      toast.error("Please enter phone number");
      return;
    }
  
    if (role === "") {
      toast.error("Please select role");
      return;
    }
    
    if (teamMemberId !== "") {
      updateTeamMember();
    } else {
      createTeamMember();
    }
  };

  const createTeamMember = () => {
    let _mobileNumber = "";
    if (!isNullOrEmpty(mobileNumber)) {
      if (!validatePhoneNumber(mobileNumber, "+" + mobileNumberCountryCode)) {
        toast.error("Please enter valid phone number");
        return;
      } else {
        _mobileNumber = mobileNumberCountryCode + "-" + mobileNumber;
      }
    }else{
      toast.error("Please enter phone number");
        return;
    }
    

    const createTeamMemberRequest = {
      firstName: teamMember.firstName,
      lastName: teamMember.lastName,
      displayName: teamMember.displayName,
      email: teamMember.email,
      // contactNumber: teamMember.contactNumber,
      contactNumber: _mobileNumber,
      role: role,
    };
    setSaveBtnDisabled(true);
    setCancelBtnDisabled(true);
    TeamMemberService.addEmployerTeamMember(createTeamMemberRequest).then(
      (response) => {
        setSaveBtnDisabled(false);
        setCancelBtnDisabled(false);
        try {
          if(response.status === 200){
            toast.success("Member created successfully");
            getAllTeamMembers(sortOrder, sortBy, currentPage);
          }
        } catch (err) {
          console.log(err);
        }
      }
      
    );
    setModalRight(false);
  };

  const cancelButton = () => {
    setSaveBtnDisabled(false);
    setCancelBtnDisabled(false);
    setModalRight(false);
  };

  const updateTeamMember = () => {
    let _mobileNumber = "";
    if (!isNullOrEmpty(mobileNumber)) {
      if (!validatePhoneNumber(mobileNumber, "+" + mobileNumberCountryCode)) {
        toast.error("Please enter valid phone number");
        return;
      } else {
        _mobileNumber = mobileNumberCountryCode + "-" + mobileNumber;
      }
    }else{
      toast.error("Please enter phone number");
      return;
    }

    const updateTeamMemberRequest = {
      firstName: teamMember.firstName,
      lastName: teamMember.lastName,
      displayName: teamMember.displayName,
      email: teamMember.email,
      // contactNumber: teamMember.contactNumber,
      contactNumber: _mobileNumber,
      role: role,
    };
    setSaveBtnDisabled(true);
    setCancelBtnDisabled(true);
    TeamMemberService.updateEmployerTeamMember(
      updateTeamMemberRequest,
      teamMemberId
    ).then((response) => {
      setSaveBtnDisabled(false);
      setCancelBtnDisabled(false);
      try {

        if(response.status === 200){
          toast.success("Member updated successfully");
          getAllTeamMembers(sortOrder, sortBy, currentPage);
          setTeamMemberId("");
          setTeamMember((prevState) => ({
            ...prevState,
            firstName: "",
            lastName: "",
            displayName:"",
            email: "",
            // contactNumber: "",
            role: "",
          }));
          setContactNumber("");
        }
        
      } catch (err) {
        console.log(err);
      }
    });
    setModalRight(false);
  };

  const handleactivate = (teamMemberId) => {
    setModalactivate(teamMemberId);
  };

  const activateTeamMember = () => {
    TeamMemberService.activateEmployerTeamMember(modalactivate).then(
      (response) => {
        try {
          toast.success("Member Activated Successfully");
          getAllTeamMembers(sortOrder, sortBy, currentPage);
        } catch (err) {
          console.log(err);
        }
        setModalactivate(false);
      }
    );
  };

  const handleinactivate = (teamMemberId) => {
    setModalinactive(teamMemberId);
  };

  const inActivateTeamMember = () => {
    TeamMemberService.inactivateEmployerTeamMember(modalinactive).then(
      (response) => {
        try {
          toast.success("Member Inactivated Successfully");
          getAllTeamMembers(sortOrder, sortBy, currentPage);
        } catch (err) {
          console.log(err);
        }
        setModalinactive(false);
      }
    );
  };

  const getTeamMemberDetails = (teamMember) => {
    setRole(teamMember.role);

    setModalRight(true);
    setTeamMember((prevState) => ({
      ...prevState,
      firstName: teamMember.firstName,
      lastName: teamMember.lastName,
      displayName: teamMember.displayName,
      email: teamMember.email,
      // contactNumber: teamMember.contactNumber,
      role: teamMember.role,
    }));
  
    setSelectedTeamMember(teamMember);
    setTeamMemberId(teamMember.id);

    if(!isNullOrEmpty(teamMember.contactNumber)){
      setContactNumber(teamMember.contactNumber);

      let countryCode = getCountryCodefromMobile(teamMember.contactNumber);
      setMobileNumberCountryCode(countryCode);
      let mobileNumber = getMobileNumberCountryCode(
        teamMember.contactNumber
      );
      setMoblieNumber(mobileNumber);
    }

  };

  const displayTableHeaders = () => {
    return (
      <>
        <th className="w-5">S.No</th>
        <th onClick={() => sortByMembers("firstName")} className="w-15">
          <Row className="w-[150]">
            {" "}
            <div className="col pr-1 t-cursor-pointer"> First Name </div>
            <div className="col-4">
              {sortBy == "firstName" ? (
                <>
                  {sortBy === "firstName" &&
                    (sortOrder === "asc" ? (
                      <>
                        <Row>
                          <SvgSelectedUpArrow />
                        </Row>
                        <Row>
                          <SvgDownArrow />
                        </Row>
                      </>
                    ) : (
                      <>
                        <Row>
                          <SvgUpArrow />
                        </Row>
                        <Row>
                          {" "}
                          <SvgSelectedDownArrow />
                        </Row>
                      </>
                    ))}
                </>
              ) : (
                <>
                  {" "}
                  <Row>
                    <SvgUpArrow />
                  </Row>
                  <Row>
                    <SvgDownArrow />
                  </Row>
                </>
              )}
            </div>
          </Row>
        </th>
        <th onClick={() => sortByMembers("lastName")} className="w-10">
          <Row className="w-[150]">
            {" "}
            <div className="col pr-1 t-cursor-pointer"> Last Name </div>
            <div className="col-4">
              {sortBy == "lastName" ? (
                <>
                  {sortBy === "lastName" &&
                    (sortOrder === "asc" ? (
                      <>
                        <Row>
                          <SvgSelectedUpArrow />
                        </Row>
                        <Row>
                          <SvgDownArrow />
                        </Row>
                      </>
                    ) : (
                      <>
                        <Row>
                          <SvgUpArrow />
                        </Row>
                        <Row>
                          {" "}
                          <SvgSelectedDownArrow />
                        </Row>
                      </>
                    ))}
                </>
              ) : (
                <>
                  {" "}
                  <Row>
                    <SvgUpArrow />
                  </Row>
                  <Row>
                    <SvgDownArrow />
                  </Row>
                </>
              )}
            </div>
          </Row>
        </th>

        <th onClick={() => sortByMembers("displayName")} className="w-10">
          <Row className="w-[200]">
            {" "}
            <div className="col pr-1 t-cursor-pointer"> Display Name </div>
            <div className="col-4">
              {sortBy == "displayName" ? (
                <>
                  {sortBy === "displayName" &&
                    (sortOrder === "asc" ? (
                      <>
                        <Row>
                          <SvgSelectedUpArrow />
                        </Row>
                        <Row>
                          <SvgDownArrow />
                        </Row>
                      </>
                    ) : (
                      <>
                        <Row>
                          <SvgUpArrow />
                        </Row>
                        <Row>
                          {" "}
                          <SvgSelectedDownArrow />
                        </Row>
                      </>
                    ))}
                </>
              ) : (
                <>
                  {" "}
                  <Row>
                    <SvgUpArrow />
                  </Row>
                  <Row>
                    <SvgDownArrow />
                  </Row>
                </>
              )}
            </div>
          </Row>
        </th>

        <th onClick={() => sortByMembers("email")} className="w-20">
          <Row className="w-[100]">
            {" "}
            <div className="col pr-1 t-cursor-pointer"> Email </div>
            <div className="col">
              {sortBy == "email" ? (
                <>
                  {" "}
                  {sortBy === "email" &&
                    (sortOrder === "asc" ? (
                      <>
                        <Row>
                          <SvgSelectedUpArrow />
                        </Row>
                        <Row>
                          <SvgDownArrow />
                        </Row>
                      </>
                    ) : (
                      <>
                        <Row>
                          <SvgUpArrow />
                        </Row>
                        <Row>
                          {" "}
                          <SvgSelectedDownArrow />
                        </Row>
                      </>
                    ))}
                </>
              ) : (
                <>
                  <Row>
                    <SvgUpArrow />
                  </Row>
                  <Row>
                    <SvgDownArrow />
                  </Row>
                </>
              )}
            </div>
          </Row>
        </th>
        <th onClick={() => sortByMembers("contactNumber")} className="w-15">
          <Row className="w-[200]">
            {" "}
            <div className="col pr-1 t-cursor-pointer">Phone Number</div>
            <div className="col-4">
              {sortBy === "contactNumber" ? (
                <>
                  {sortBy === "contactNumber" &&
                    (sortOrder === "asc" ? (
                      <>
                        {" "}
                        <Row>
                          <SvgSelectedUpArrow />
                        </Row>
                        <Row>
                          <SvgDownArrow />
                        </Row>
                      </>
                    ) : (
                      <>
                        <Row>
                          <SvgUpArrow />
                        </Row>
                        <Row>
                          {" "}
                          <SvgSelectedDownArrow />
                        </Row>
                      </>
                    ))}
                </>
              ) : (
                <>
                  {" "}
                  <Row>
                    <SvgUpArrow />
                  </Row>
                  <Row>
                    <SvgDownArrow />
                  </Row>
                </>
              )}
            </div>
          </Row>
        </th>

        <th onClick={() => sortByMembers("role")} className="w-10">
          <Row className="w-[100]">
            {" "}
            <div className="col pr-1 t-cursor-pointer"> Role </div>
            <div className="col-4">
              {sortBy === "role" ? (
                <>
                  {" "}
                  {sortBy === "role" &&
                    (sortOrder === "asc" ? (
                      <>
                        <Row>
                          <SvgSelectedUpArrow />
                        </Row>
                        <Row>
                          <SvgDownArrow />
                        </Row>
                      </>
                    ) : (
                      <>
                        <Row>
                          <SvgUpArrow />
                        </Row>
                        <Row>
                          {" "}
                          <SvgSelectedDownArrow />
                        </Row>
                      </>
                    ))}
                </>
              ) : (
                <>
                  {" "}
                  <Row>
                    <SvgUpArrow />
                  </Row>
                  <Row>
                    <SvgDownArrow />
                  </Row>
                </>
              )}
            </div>
          </Row>
        </th>
        <th onClick={() => sortByMembers("status")} className="w-15">
          <Row className="w-[100]">
            {" "}
            <div className="col pr-1 t-cursor-pointer"> Status </div>
            <div className="col">
              {sortBy === "status" ? (
                <>
                  {sortBy === "status" &&
                    (sortOrder === "asc" ? (
                      <>
                             <Row>
                                            <SvgSelectedUpArrow />
                                          </Row>
                                          <Row>
                                            <SvgDownArrow />
                                          </Row>
                      </>
                    ) : (
                  
                      <>
                         <Row>
                                            <SvgUpArrow />
                                          </Row>
                                          <Row>
                                            {" "}
                                            <SvgSelectedDownArrow />
                                          </Row>
                      </>
                    ))}
                </>
              ) : (
                <>
                  {" "}
                  <Row>
                                      <SvgUpArrow />
                                    </Row>
                                    <Row>
                                      <SvgDownArrow />
                                    </Row>
                </>
              )}
            </div>
          </Row>
        </th>
        <th className="w-10">Actions</th>
      </>
    );
  };

  const selectWithRole = () => {
    return (
      <>
       {(role !== "MASTER_ADMIN" ? (
            <>
            <Label>Role*</Label>
              <Input
                    className="t-rounded-lg"
                    type="select"
                    id="role"
                    value={role}
                    onChange={(e) => handleUserRoleSelectChange(e)}
                  >
                    <option value={""}>{"Select Role"}</option>
                    {userRoleOptions.length > 0 &&
                      userRoleOptions.map((role) => {
                        if (role.key === "ADMIN" || role.key === "TALENT_ADVISOR") {
                          return (
                            <option key={role.key} value={role.key}>
                              {role.value}
                            </option>
                          );
                        }
                      })}
              </Input>
           
            </>
          ) : (                  
            <>               
            </>
          ))}
       
      </>
    );
  };

  const displayTableRoles = (teamMember) => {
    return (
      <>
        {(() => {
          if (teamMember.role === "TALENT_ADVISOR") {
            return <div>Talent Advisor</div>;
          } else if (teamMember.role === "MASTER_ADMIN") {
            return <div>Master Admin</div>;
          } else if (teamMember.role === "ADMIN") {
            return <div>Admin</div>;
          }
        })()}
      </>
    );
  };

  const displayTableStatus = (teamMember) => {
    return (
      <>
        {(() => {
          if (teamMember.status === "ACTIVE") {
            return <div>Active</div>;
          } else if (teamMember.status === "INACTIVE") {
            return <div>InActive</div>;
          } else if (teamMember.status === "TERMINATED") {
            return <div>Terminated</div>;
          }
        })()}
      </>
    );
  };

  const displayTableActions = (teamMember) => {
    return (
      <>
        <div >
          {window.localStorage.getItem("user") !== teamMember.id ? (
            teamMember.role !== "MASTER_ADMIN" ? (
              <>
                {(() => {
                  if (teamMember.status === "ACTIVE") {
                    return (
                      <div>
                        <i
                          className="simple-icon-note edit-copyiconsize arrow-icon-color mr-2 emp_icon t-cursor-pointer"
                          title="Edit Member"
                          onClick={(e) => {
                            getTeamMemberDetails(teamMember);
                          }}
                        />
                        <i
                          className="simple-icon-lock-open edit-copyiconsize arrow-icon-color mr-2 emp_icon t-cursor-pointer"
                          title="Inactivate Member"
                          onClick={(e) => {
                            handleinactivate(teamMember.id);
                          }}
                        />

                        <i
                          className="simple-icon-trash edit-copyiconsize arrow-icon-color mr-3 t-cursor-pointer"
                          title=" Terminate Member"
                          onClick={() =>
                            handleMemberdelete(
                              teamMember.id,
                              teamMember.firstName + "" + teamMember.lastName
                            )
                          }
                        />
                      </div>
                    );
                  } else if (teamMember.status === "INACTIVE") {
                    return (
                      <div>
                        <i
                          className="simple-icon-lock edit-copyiconsize arrow-icon-color mr-2 emp_icon t-cursor-pointer"
                          title="Activate Member"
                          onClick={(e) => {
                            handleactivate(teamMember.id);
                          }}
                        />

                        <i
                          className="simple-icon-trash edit-copyiconsize arrow-icon-color mr-3 t-cursor-pointer"
                          title=" Terminate Member"
                          onClick={() =>
                            handleMemberdelete(
                              teamMember.id,
                              teamMember.firstName + "" + teamMember.lastName
                            )
                          }
                        />
                      </div>
                    );
                  }
                })()}
              </>
            ) : (
              <>
              </>
            )
          ) : (
            <>
            <div>
                <i
                  className="simple-icon-note edit-copyiconsize arrow-icon-color mr-2 emp_icon t-cursor-pointer"
                  title="Edit Member"
                  onClick={(e) => {
                    getTeamMemberDetails(teamMember);
                  }}
                />
              </div>
            
            </>
          )}
        </div>
      </>
    );
  };

  const openModel = () => {
    setModalRight(true);
    setTeamMemberId("");
    setRole("");
    setTeamMember((prevState) => ({
      ...prevState,
      firstName: "",
      lastName: "",
      displayName:"",
      email: "",
      // contactNumber: "",
      role: "",
    }));
    setContactNumber("");
    setMobileNumberCountryCode('');
    setMoblieNumber('');
  };

  const getSerialNumber = (index) => {
    if (itemsPerPage === undefined || itemsPerPage === "") {
      itemsPerPage = 25;
    }
    return (currentPage - 1) * itemsPerPage + index + 1;
  };

  return (
    <>
      <div>
        <div>
          <Card className="mt-2">
            <CardHeader>
              <div>
                <Row>
                  <Colxx xxs="12">
                    <div className="skill-header">
                      <strong>Members</strong>
                      <Button
                        color="primary"
                        outline
                        size="sm"
                        onClick={openModel}
                      >
                        Add
                      </Button>

                      <Modal
                        isOpen={Boolean(modalRight)} 
                        toggle={() => setModalRight(!modalRight)}
                        wrapClassName="modal-right"
                      >
                        <ModalHeader className="Modal-header-account">
                          {teamMemberId === "" ? (
                            <strong>Create New Member</strong>
                          ) : (
                            <strong>Update Member</strong>
                          )}
                        </ModalHeader>
                        <ModalBody>
                          <Form>
                            <FormGroup row>
                              <Colxx sm={12}>
                                <FormGroup>
                                  <Label>
                                    First Name*
                                    {/* <span className="required-star"></span> */}
                                  </Label>
                                  <Input
                                    className="t-rounded-lg"
                                    type="firstName"
                                    name="firstName"
                                    data-testid="member-firstName"
                                    onChange={inputsHandler}
                                    value={teamMember.firstName}
                                  />
                                </FormGroup>
                              </Colxx>
                              <Colxx sm={12}>
                                <FormGroup>
                                  <Label>
                                    Last Name*
                                    {/* <span className="required-star"></span> */}
                                  </Label>
                                  <Input
                                    className="t-rounded-lg"
                                    type="lastName"
                                    name="lastName"
                                    data-testid="member-lastName"
                                    onChange={inputsHandler}
                                    value={teamMember.lastName}
                                  />
                                </FormGroup>
                              </Colxx>
                              <Colxx sm={12}>
                                <FormGroup>
                                  <Label>
                                    Display Name*
                                  </Label>
                                  <Input
                                    className="t-rounded-lg"
                                    type="text"
                                    name="displayName"
                                    data-testid="member-displayName"
                                    onChange={inputsHandler}
                                    value={teamMember.displayName}
                                  />
                                </FormGroup>
                              </Colxx>
                              <Colxx sm={12}>
                                <FormGroup>
                                  <Label>
                                    Email*
                                    {/* <span className="required-star"></span> */}
                                  </Label>
                                  <Input
                                    className="t-rounded-lg"
                                    type="email"
                                    name="email"
                                    data-testid="member-email"
                                    onChange={inputsHandler}
                                    value={teamMember.email}
                                    // placeholder={"Email"}
                                  />
                                </FormGroup>
                              </Colxx>

                              <Colxx sm={12}>
                                <FormGroup>
                                  <Label>
                                    Phone Number*
                                    {/* <span className="required-star"></span> */}
                                  </Label>
                                  <PhoneInput
                                    country="us"
                                    // regions={["north-america"]}
                                    countryCodeEditable={false}
                                    type="contactNumber"
                                    name="contactNumber"
                                    data-testid="member-contactNumber"
                                    // placeholder={"Phone Number"}
                                    onChange={handleContactNumber}
                                    value={contactNumber}
                                  />
                                </FormGroup>
                              </Colxx>
                              <Colxx sm={12}>
                                <FormGroup>
                                  {selectWithRole()}
                                </FormGroup>
                              </Colxx>
                            </FormGroup>
                          </Form>
                        </ModalBody>

                        <ModalFooter className="model-button modal-bottom-account">
                          <Button
                            color="primary"
                            size="sm"
                            outline
                            onClick={SubmitMemberInfo}
                            disabled={saveBtnDisabled}
                          >
                            Save
                          </Button>

                          <Button
                            color="primary"
                            size="sm"
                            outline
                            className=" ml-1"
                            onClick={cancelButton}
                            disabled={cancelBtnDisabled}
                          >
                            Cancel
                          </Button>
                        </ModalFooter>
                      </Modal>
                    </div>
                  </Colxx>
                </Row>
              </div>
            </CardHeader>

            <Accordion defaultActiveKey="0" className="Search-accordion">
              <div className="job-req-search-card">
                <Accordion.Item eventKey="0">
                  <Accordion.Header className="search-accordion-header ">
                    Search
                  </Accordion.Header>
                  <Accordion.Body>
                    <div className="mb-3">
                      <Row>
                        <Colxx md={3} className="">
                          <Input
                            type="text"
                            className="form-control t-rounded-lg"
                            name=""
                            placeholder="Search"
                            onChange={handleSearch}
                            value={search}
                          />
                        </Colxx>
                        <Colxx md={3}>
                          <Input
                            className="t-rounded-lg"
                            type="select"
                            value={userStatus}
                            onChange={handleUserStatusSelectChange}
                          >
                            <option value={""}>Select Status</option>
                            {userStatusOptions.map(({ value, key }) => (
                              <option key={key} value={key}>
                                {value}
                              </option>
                            ))}
                          </Input>
                        </Colxx>
                        <Colxx md={3}>
                          <Input
                            className="t-rounded-lg"
                            type="select"
                            value={searchRole}
                            onChange={handleUserRoleSearchChange}
                          >
                            <option value={""}>Select Role</option>
                            {userRoleOptions.map(({ value, key }) => (
                              <option key={key} value={key}>
                                {value}
                              </option>
                            ))}
                          </Input>
                        </Colxx>
                        <Colxx md={3} className="">
                          <Input
                            className="t-rounded-lg"
                            type="select"
                            value={itemsPerPage}
                            onChange={handleItemsPerChange}
                          >
                            <option value={""}>Items per page</option>
                            <option value={"10"}>10</option>
                            <option value={"25"}>25</option>
                            <option value={"50"}>50</option>
                            <option value={"100"}>100</option>
                          </Input>
                        </Colxx>
                        <Colxx md={10} className="">
                          <div className="row col-sm-12 col-form-label">
                            <div className="">
                              <Button
                                color="primary"
                                size="sm"
                                outline
                                onClick={(e) =>
                                  getAllTeamMembers(sortOrder, sortBy, 1)
                                }
                              >
                                Search
                              </Button>
                            </div>
                          </div>
                        </Colxx>
                      </Row>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </div>
            </Accordion>

            <hr />

            <CardBody>
              <div className="mb-3"></div>

              <section>
                <div className="tableContainer">
                  <div className="tablewrapper">
                    <Table className="hms_table jobRequisition_table table-responsive">
                      <thead>
                        <tr>{displayTableHeaders()}</tr>
                      </thead>
                      {members.length > 0 ? (
                        members.map((teamMember, index) => {
                          return (
                            <tbody key={index}>
                              <tr>
                                <td className="w-[60]">
                                  {getSerialNumber(index)}
                                </td>
                                <td className="w-[120]">
                                  {teamMember.firstName}
                                </td>
                                <td className="w-[120]">
                                  {teamMember.lastName}
                                </td>
                                <td className="w-[120]">
                                  {teamMember.displayName}
                                </td>
                                <td className="w-[180]">{teamMember.email}</td>
                                <td className="w-[180]">
                                  {formattedMobileNumber(teamMember.contactNumber)}
                                </td>
                                <td className="w-[120]">
                                  {displayTableRoles(teamMember)}
                                </td>
                                <td className="w-[120]">
                                  {displayTableStatus(teamMember)}
                                </td>
                                <td className="w-[120]">
                                  {displayTableActions(teamMember)}
                                </td>
                              </tr>
                            </tbody>
                          );
                        })
                      ) : (
                        <></>
                      )}
                    </Table>
                  </div>
                </div>
              </section>

              {members.length > 0 ? (
                <></>
              ) : (
                <p className="nodata-text">No members available</p>
              )}
            </CardBody>

            <CardFooter>
              <Row className="wrapper">
                <h3 className="ml-3 matrecords">
                  {" "}
                  Total matching records : {size}
                </h3>
                <Pagination
                  currentPage={currentPage}
                  totalPage={totalPage}
                  numberLimit={itemsPerPage}
                  firstIsActive={true}
                  onChangePage={(e) => onChangePage(e)}
                />
              </Row>
            </CardFooter>
          </Card>
        </div>
      </div>
      <Modal
        isOpen={Boolean(modalinactive)}
        toggle={() => setModalinactive(!modalinactive)}
      >
        <ModalBody>
          Do you want to <strong>Inactivate Member</strong>
        </ModalBody>
        <ModalFooter className="p-3">
          {" "}
          <Button
            color="primary"
            size="sm"
            outline
            onClick={() => setModalinactive(false)}
          >
            No
          </Button>
          <Button
            color="primary"
            size="sm"
            outline
            onClick={() => {
              inActivateTeamMember();
            }}
          >
            Yes
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
        isOpen={Boolean(modalactivate)}
        toggle={() => setModalactivate(!modalactivate)}
      >
        <ModalBody>
          Do you want to <strong>Activate Member</strong>
        </ModalBody>
        <ModalFooter className="p-3">
          {" "}
          <Button
            color="primary"
            size="sm"
            outline
            onClick={() => setModalactivate(false)}
          >
            No
          </Button>
          <Button
            color="primary"
            size="sm"
            outline
            onClick={() => {
              activateTeamMember();
            }}
          >
            Yes
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={Boolean(modalDelete)} toggle={() => setModalDelete(!modalDelete)}>
        <ModalBody>
          Do you want to delete member <strong> {"  " + memberName}</strong>?
        </ModalBody>
        <ModalFooter className="p-3">
          {" "}
          <Button
            color="primary"
            size="sm"
            outline
            onClick={() => setModalDelete(false)}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            size="sm"
            outline
            onClick={(e) => {
              removeTeamMember();
            }}
          >
            Delete
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default MembersList;
